import React, {memo} from 'react';

import Barcode from 'react-barcode';

import sofiifka from './sofiivka.jpg';
import novaSofiifka from './nova_sofiivka.jpg';
import './styles.css';

const Ticket = ({number, service, cost, valid_until, park}) => {

    const logoRef = {
        1: novaSofiifka,
        2: sofiifka,
    };

    const readableDate = (date) => {
        date = new Date(date);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${day}.${month}.${year}`;
    };

    return (
        <div className="ticket">
            <img id="ticket-logo" src={logoRef[park]} alt="logo"/>
            <h2 className="ticket-header"><b>КВИТОК</b></h2>
            <h2 className="ticket-service">&laquo;{service.name}&raquo;</h2>
            {cost > 0 && (
                <div className="ticket-amount">
                    <span>{cost} грн.</span>
                </div>
            )}
            <div className='barcode-wrapper'>
                <Barcode
                    value={number}
                    textPosition='bottom'
                    format='CODE128B'
                    font='GothamPro'
                    fontSize={28}
                />
            </div>
            <p>Використати до {readableDate(valid_until)}</p>
            <p>Зберігати до кінця відвідування.</p>
            <p>www.sofievka.org</p>
            <div className="bottom-spacer"/>
        </div>
    )
};

export default memo(Ticket);